import { Address } from '../Model/address';

export abstract class GeocodingService {
    abstract getAddressesByCoordinates(lat: number, lng: number): Promise<Address[]>;
}
